import { type RouteRecordRaw } from 'vue-router'

const vesselsRoutes: Array<RouteRecordRaw> = [
  {
    path: '/settings/vessels',
    name: 'vessels.index',
    component: () => import('@/modules/vessel/views/VesselsIndex.vue'),
    meta: {
      pageTitle: 'Vessels',
      breadcrumbs: ['Vessels']
    }
  },
  {
    path: '/settings/vessels/:id/particulars',
    name: 'vessels.particulars',
    component: () => import('@/modules/vessel/views/VesselsParticulars.vue'),
    meta: {
      pageTitle: 'Vessel Particulars',
      breadcrumbs: ['Vessels', 'Particulars']
    }
  },
  {
    path: '/settings/vessels/:id/:tab?',
    name: 'vessels.show',
    component: () => import('@/modules/vessel/views/VesselsShow.vue'),
    meta: {
      pageTitle: 'Vessel Summary',
      breadcrumbs: ['Vessels']
    }
  },
  {
    path: '/settings/vessels/create',
    name: 'vessels.create',
    component: () => import('@/modules/vessel/views/VesselsEdit.vue'),
    meta: {
      pageTitle: 'Vessel Create',
      breadcrumbs: ['Vessels']
    }
  },
  {
    path: '/settings/vessels/:id/edit',
    name: 'vessels.edit',
    component: () => import('@/modules/vessel/views/VesselsEdit.vue'),
    meta: {
      pageTitle: 'Vessel Edit',
      breadcrumbs: ['Vessels']
    }
  }
]

export default vesselsRoutes
